const getSection = (state, action) => {
  switch (action.status) {
    case 'started':
      return {
        ...state,
        isLoadingContent: true,
        sectionId: action.payload.sectionId,
      };
    case 'aborted':
      return {
        ...state,
        isLoadingContent: false,
      };
    case 'success':
      return {
        ...state,
        selectedContent:
          state.sectionId === action.payload.sectionId
            ? action.payload.content
            : state.content,
        isLoadingContent: false,
        sectionId: action.payload.sectionId,
      };
    case 'error':
      return {
        ...state,
        selectedContent: null,
        isLoadingContent: false,
      };
    default:
      return state;
  }
};

export default getSection;
